(function () {
  function getHeaderOffset() {
    const headerHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--m-header-height') || '0',
      10
    );

    return (Number.isNaN(headerHeight) ? 0 : headerHeight) + 20;
  }

  function scrollToElement(element) {
    if (!element) return;

    const top = element.getBoundingClientRect().top + window.scrollY - getHeaderOffset();

    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });

    if (element.id) {
      history.replaceState(null, '', '#' + element.id);
    }
  }

  function scrollToTarget(targetId, fallbackIds) {
    let target = targetId ? document.getElementById(targetId) : null;

    if (!target && fallbackIds) {
      for (let i = 0; i < fallbackIds.length; i++) {
        target = document.getElementById(fallbackIds[i]);
        if (target) break;
      }
    }

    scrollToElement(target);
  }

  function initPostReloadScroll() {
    const trigger = document.querySelector('[data-form-scroll-trigger], [data-comment-scroll-trigger]');
    if (!trigger) return;

    const targetId = trigger.dataset.formScrollTarget || trigger.dataset.commentScrollTarget;
    const fallbacks = trigger.hasAttribute('data-comment-scroll-trigger')
      ? ['m-comments', 'm-leave-comment']
      : ['m-contact-form-section'];

    requestAnimationFrame(function () {
      scrollToTarget(targetId, fallbacks);
    });
  }

  function init() {
    initPostReloadScroll();
  }

  window.MinimogFormScroll = {
    scrollToElement: scrollToElement,
    scrollToTarget: scrollToTarget,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
